export async function getCustomData(request, ident) {
    const data = await request({
        url: "/profile/custom-data/" + ident,
        method: "get"
      });
    return data;
}

export async function updateCustomData(request, via, customData) {
    const res = await request({
        method: "post",
        url: "/profile/custom-data/",
        data: {
          via: via,
          data: customData,
        },
      });
    return res;
}
